import { LangCode } from "@/lib/gql/__generated__/graphql";

export const CapacityPrefix: { [key: LangCode[number]]: string } = {
	[LangCode.Default]: "名",
	[LangCode.En]: "person(s)",
};

export const LastSevenDaysStatement: { [key: LangCode[number]]: string } = {
	default: "直近7日間",
	en: "last seven days",
};

export const Person: { [key: LangCode[number]]: string } = {
	default: "X名",
	en: "X person〜",
};
